export default function Subtitle({ className, text }) {
  return (
    <p
      className={`py-5 font-serif leading-tight text-slate-900 font-semibold tracking-tight ${className}`}
    >
      {text}
    </p>
  );
}
